import type { WorkerSchema } from '../types'

/** UI schema for outstanding balance announcements (client-side data, not an API worker). */
export const BillLinReceivableSchema: WorkerSchema = {
  workerId: 'bill-lin-receivable',
  workerLabel: 'ยอดค้าง',
  tabIcon: 'hand-coins',
  recordPrefix: 'RC',
  apiEndpoint: '',
  defaultSort: { col: 'created_at', dir: 'desc' },
  searchFields: ['customer_ref', 'amount', 'amount_original'],

  columns: [
    {
      id: 'customer_ref',
      header: 'ลูกค้า/รายการ',
      type: 'text',
      editable: false,
      sortable: true,
      visibility: 'always',
    },
    {
      id: 'amount_original',
      header: 'ยอดเต็ม',
      type: 'amount',
      editable: false,
      sortable: true,
      visibility: 'always',
      align: 'right',
    },
    {
      id: 'amount_paid',
      header: 'รับแล้ว',
      type: 'amount',
      editable: false,
      sortable: true,
      visibility: 'always',
      align: 'right',
    },
    {
      id: 'amount',
      header: 'รอจัดสรร',
      type: 'amount',
      editable: false,
      sortable: true,
      visibility: 'always',
      align: 'right',
    },
    {
      id: '__status__',
      header: 'สถานะ',
      type: 'status',
      editable: false,
      visibility: 'always',
    },
    // Drawer / detail only — table ends at สถานะ (no ครบกำหนด column)
    {
      id: 'expires_at',
      header: 'ครบกำหนด',
      type: 'text',
      editable: false,
      sortable: true,
      visibility: 'hidden',
      width: 168,
    },
    {
      id: 'created_at',
      header: 'วันเวลาแจ้ง',
      type: 'datetime',
      editable: false,
      sortable: true,
      visibility: 'hidden',
      width: 150,
    },
  ],

  drawerSections: [
    {
      label: 'CUSTOMER',
      fields: ['customer_ref', 'addr_name', 'addr_phone', 'phone'],
    },
    {
      label: 'DETAILS',
      fields: [
        'amount_original',
        'amount_paid',
        'amount',
        'expires_at',
        'created_at',
        'queue_left_at',
        'queue_left_reason',
        'updated_at',
        'recorded_at',
        'record_date',
        'remark',
      ],
    },
  ],

  filterOptions: {
    status: ['ค้าง', 'รอตรวจ', 'รับบางส่วน', 'รายการที่ลบ', 'หมดอายุ'],
    datePresets: [
      'วันนี้',
      '7 วันที่ผ่านมา',
      'เดือนนี้',
      'เดือนที่แล้ว',
      'กำหนดเอง',
    ],
  },

  emptyState: {
    icon: '💰',
    title: 'ไม่มียอดค้าง',
    body: 'เปิดแชตบิลลินในไลน์เพื่อประกาศยอดค้างและติดตามการชำระได้เลยครับ',
  },
}
